import * as swcHelpers from '@swc/helpers';
import React__default, { useMemo } from 'react';
import classnames from 'classnames';
import ButtonLoader from '../ButtonLoader/ButtonLoader.js';

const RoundedButton = (_param)=>{
    var { children , className , type ='button' , variant , size , loading , loadingLabel  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "type",
        "variant",
        "size",
        "loading",
        "loadingLabel"
    ]);
    const classes = useMemo(()=>classnames('rounded-button', `rounded-button--${variant}`, {
            [`rounded-button--${size}`]: size && size !== 'medium'
        }, className)
    , [
        className,
        variant,
        size
    ]);
    const a11y = useMemo(()=>{
        if (!loading) {
            return {};
        }
        return swcHelpers.objectSpread({
            role: 'status',
            'aria-live': 'polite'
        }, loadingLabel && {
            'aria-label': loadingLabel
        });
    }, [
        loading,
        loadingLabel
    ]);
    return /*#__PURE__*/ React__default.createElement("button", swcHelpers.extends({
        type: type,
        className: classes
    }, props, a11y), loading ? /*#__PURE__*/ React__default.createElement(ButtonLoader, null) : children);
};
var RoundedButton$1 = RoundedButton;

export { RoundedButton$1 as default };
//# sourceMappingURL=RoundedButton.js.map
